export default {
  'ACTIVITY.WHATSAPP.MENU.TITLE': 'WhatsApp campaigns',
  'ACTIVITY.WHATSAPP.LIST.TITLE': 'Campaign List',
  'ACTIVITY.WHATSAPP.LIST.CREATE.ACTIVITY': 'Create WhatsApp campaign',
  'ACTIVITY.WHATSAPP.LIST.DRAFT': 'Draft',
  'ACTIVITY.WHATSAPP.LIST.SCHEDULED': 'Scheduled',
  'ACTIVITY.WHATSAPP.LIST.ONGOING': 'Ongoing',
  'ACTIVITY.WHATSAPP.LIST.COMPLETED': 'Completed',
  'ACTIVITY.WHATSAPP.LIST.CANCELLED': 'Terminated',
  'ACTIVITY.WHATSAPP.LIST.PAUSED': 'Paused',
  'ACTIVITY.WHATSAPP.LIST.ERROR': 'Interrupted',
  'ACTIVITY.WHATSAPP.LIST.ERROR.TIPS':
    'Delivery was interrupted because there was an issue (e.g. Account limited).<br> Please contact the SmartLink team for support.',
  'ACTIVITY.WHATSAPP.LIST.NAME': 'Name',
  'ACTIVITY.WHATSAPP.LIST.STATUS': 'Status',
  'ACTIVITY.WHATSAPP.LIST.CREATE_TIME': 'Create Time',
  'ACTIVITY.WHATSAPP.LIST.LAST_UPDATE_TIME': 'Last update time',
  'ACTIVITY.WHATSAPP.LIST.UPDATE_TIME': 'Update time',
  'ACTIVITY.WHATSAPP.LIST.OPERATION': 'Action',
  'ACTIVITY.WHATSAPP.LIST.CREATE_BY': 'Create by',
  'ACTIVITY.WHATSAPP.LIST.START_TIME': 'Start time',
  'ACTIVITY.WHATSAPP.LIST.LAST_UPDATE_BY': 'Last update by',
  'ACTIVITY.WHATSAPP.LIST.RECIPIENTS': 'Recipients',
  'ACTIVITY.WHATSAPP.LIST.CREATE.NAME': 'Campaign Name',
  'ACTIVITY.WHATSAPP.LIST.CREATE.ENTER.PLACEHOLDER': 'Enter Campaign Name',
  'ACTIVITY.WHATSAPP.LIST.CREATE.DESC1':
    'Create and launch WhatsApp campaigns within a few minutes. Select the sender, recipients, message template, and set a delivery time.',
  'ACTIVITY.WHATSAPP.LIST.RESTART': 'Restart',
  'ACTIVITY.WHATSAPP.LIST.DETAILS': 'Campaign  Details',
  'ACTIVITY.WHATSAPP.LIST.VIEW.REPORT': 'View Report',
  // create
  'ACTIVITY.WHATSAPP.CREATE.SENDER': 'Sender',
  'ACTIVITY.WHATSAPP.CREATE.SENDER.TIPS':
    'Set the sender details for this campaign',
  'ACTIVITY.WHATSAPP.CREATE.SENDER.NUMBER': 'Sender number',
  'ACTIVITY.WHATSAPP.CREATE.SENDER.SELECT.PLACEHOLDER': 'Select account',
  'ACTIVITY.WHATSAPP.CREATE.SENDER.SEARCH.PLACEHOLDER': 'Search',
  'ACTIVITY.WHATSAPP.CREATE.SENDER.NUMBER.DISPATCH':
    'Please select sender number',
  'ACTIVITY.WHATSAPP.CREATE.SENDER.NUMBER.DISPATCH.TIPS':
    'No account connected yet. Please reach out to your SmartLink contact or contact ',
  'ACTIVITY.WHATSAPP.CREATE.SENDER.NUMBER.DISPATCH.EMAIL':
    'SmartLink_service@proximabeta.com',
  'ACTIVITY.WHATSAPP.CREATE.CONTENT.DISABLED.TIPS':
    'No approved templates available. Templates will be available after approval from Meta, please wait.',
  'ACTIVITY.WHATSAPP.CREATE.RECIPIENTS.STATISTICS': `<div class="font-size-14"><b class="color-primary font-size-16 font-poppins">{total}</b><b> WhatsApp subscribers (The number of recipients is updated automatically after campaign is launched)</div>`,
  'ACTIVITY.WHATSAPP.CREATE.RECIPIENTS': 'Recipients',
  'ACTIVITY.WHATSAPP.CREATE.RECIPIENTS.NO.SUBSCRIPTION':
    "Warning: This tag has 0 WhatsApp subscribers, campaigns can't be sent to unsubscibed users.",
  'ACTIVITY.WHATSAPP.CREATE.RECIPIENTS.TIPS': 'Please select recipients',
  'ACTIVITY.WHATSAPP.CREATE.MESSAGE.TITLE': 'Message',
  'ACTIVITY.WHATSAPP.CREATE.MESSAGE.TIPS':
    'Select a template for each language',
  'ACTIVITY.WHATSAPP.CREATE.CONTENT.TEMPLATE': 'Template',
  'ACTIVITY.WHATSAPP.CREATE.CONTENT.TIPS': 'Please set content',
  'ACTIVITY.WHATSAPP.CREATE.CONTENTS.ONE': '{templateName} in {language}',
  'ACTIVITY.WHATSAPP.CREATE.CONTENTS.MORE':
    '{templateName} in {language} and {num} other language(s)',
  'ACTIVITY.WHATSAPP.CREATE.SCHEDULE': 'Schedule',
  'ACTIVITY.WHATSAPP.CREATE.SCHEDULE.TIPS': 'Please set schedule',
  'ACTIVITY.WHATSAPP.CREATE.DIRECT.RELEASE.ACTIVITY.TIPS1':
    'After the campaign is launched, its content cannot be changed anymore.',
  'ACTIVITY.WHATSAPP.SENDER.LIMIT.WITH_NUMBER':
    'This number is limited to sending<strong class="color-primary"> {number} messages </strong> per 24 hours.',
  'ACTIVITY.WHATSAPP.SENDER.LIMIT.UNLIMITED':
    'This number can send<strong> unlimited messages per 24 hours</strong>.',
  'ACTIVITY.WHATSAPP.SENDER.LIMIT.VIEW_DETAILS':
    '<a href={url} target="_blank">View details</a>',

  // 查看报表
  'ACTIVITY.WHATSAPP.LIST.REPORT.TITLE': 'WhatsApp campaign report',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS': 'Metrics',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS.RECIPIENTS': 'Recipients',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS.WATING': 'Waiting for delivery',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS.SEND': 'Sent',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS.DELIVERED': 'Delivered',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS.READ': 'Read',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS.CLICK': 'Clicked',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS.UNSUBSCRIBE': 'Unsubscribe',
  'ACTIVITY.WHATSAPP.LIST.REPORT.METRICS.REPLY': 'Replied',
  'ACTIVITY.WHATSAPP.LIST.REPORT.COUNT': 'Count',
  'ACTIVITY.WHATSAPP.LIST.REPORT.RATE': 'Rate',
  'ACTIVITY.WHATSAPP.LIST.REPORT.RATE.SEND.DETAIL':
    'Send rate = Sent / Recipients',
  'ACTIVITY.WHATSAPP.LIST.REPORT.RATE.WATING.DETAIL':
    'Queueing and waiting for the Korean night - time marketing period to pass. Remaining {time}.',
  'ACTIVITY.WHATSAPP.LIST.REPORT.RATE.DELIVERED.DETAIL':
    'Delivery rate = Delivered / Sent',
  'ACTIVITY.WHATSAPP.LIST.REPORT.RATE.READ.DETAIL':
    'Open rate = Opened / Delivered',
  'ACTIVITY.WHATSAPP.LIST.REPORT.RATE.CLICK.DETAIL': 'CTOR = Clicked / Opened',
  'ACTIVITY.WHATSAPP.LIST.REPORT.RATE.UNSUBSCRIBE.DETAIL':
    'Unsubscribe rate = Unsubscribed / Opened',
  'ACTIVITY.WHATSAPP.LIST.REPORT.RATE.REPLY.DETAIL':
    'Reply rate = Replied / Read',
  // WhatsApp hover文案
  'ACTIVITY.WHATSAPP.LIST.DRAFT.NOTE':
    'Campaign has not yet been launched. It can still be edited before launching or submitting it for approval.',
  'ACTIVITY.WHATSAPP.LIST.SCHEDULED.NOTE':
    'Campaign has been scheduled and is currently waiting for the scheduled delivery time.',
  'ACTIVITY.WHATSAPP.LIST.SENDING.ONGOING.NOTE':
    'Campaign is delivering messages since the scheduled delivery time has passed.',
  'ACTIVITY.WHATSAPP.LIST.PAUSED.NOTE':
    'Campaign has been paused manually and is currently not delivering messages.',
  'ACTIVITY.WHATSAPP.LIST.INTERRUPTED.NOTE':
    'Ongoing campaign, but delivery was interrupted because there was an issue (e.g. Account limited). ',
  'ACTIVITY.WHATSAPP.LIST.COMPLETED.NOTE': 'Campaign has been completed.',
  'ACTIVITY.WHATSAPP.LIST.TERMINATED.NOTE': 'Campaign was terminated manually.',
  // hover标题(补充)
  'ACTIVITY.WHATSAPP.LIST.SENDING': 'Sending/Ongoing',
  'ACTIVITY.WHATSAPP.LIST.PAUSEDTIP': 'Paused',
  'ACTIVITY.WHATSAPP.LIST.INTERRUPTED': 'Interrupted',
};
